<div class="flex md:flex-row flex-col gap-6 items-center justify-between mb-6">
  <h2 class="self-start">{{'personalizedJourney.title' | transloco}}</h2>
  <div class="flex flex-col gap-[0.8rem] items-end self-end">
    <progression-bar />
    @if(userRole()!="User"){
    <toggle
      [isActive]="modeDraft()"
      (toggleChange)="toggleDraftMode()"
      [text]="'components.toggle.showPendingTiles' | transloco"
    ></toggle>
    }
    <app-button
      [text]="'personalizedJourney.clarify.resetResearch' | transloco"
      [variant]="'secondary'"
      [icon]="'back'"
      [iconSize]="'1.5rem'"
      [size]="'sm'"
      (buttonClick)="redirectToJourneyResearch()"
    ></app-button>
  </div>
</div>

<div class="flex flex-col gap-6 mb-20">
  <app-journey-breadcrumb />
  <div class="bg-white rounded-xl p-6">
    <h2 class="mb-6">{{'personalizedJourney.clarify.title' | transloco}}</h2>
    <div class="flex flex-col md:flex-row gap-4">
      <div class="flex-1 rounded-xl h-fit">
        @if(!isJourneyImmature()){ @if(tilesLoading()){
        <loader />
        } @else if (questionnaireTileLoading()){
        <loader />
        } @else {
        <div class="flex flex-col gap-6">
          @for(tileProject of tilesProjectToShow(); track $index) {
          <div class="p-6 bg-vinciLavender rounded-xl flex flex-col gap-6">
            <div class="flex gap-3 items-center">
              <icon [name]="'questionnaire'" [size]="'1.875rem'" />
              <h3>{{tileProject?.title}}</h3>
            </div>
            <p
              [innerHTML]="$safeNavigationMigration(tileProject?.text) | safeHtml"
            ></p>

            <app-button
              [text]="'personalizedJourney.clarify.mobilityQuestionnaire.ctaText' | transloco"
              [variant]="'secondary'"
              [icon]="'arrow-right'"
              (buttonClick)="clickOnTile(tileProject)"
              class="w-fit"
            />
          </div>
          }
        </div>
        } } @else { @if(tilesLoading()){<loader /> } @else {
        <div class="bento-in-section gap-4">
          @for(tile of tilesProjectToShow(); track $index){
          <app-tile
            [id]="tile.id"
            [title]="tile.title"
            [text]="tile.text"
            [variant]="tile.variant"
            [ctaText]="tile.ctaText | transloco"
            [ctaLink]="tile.ctaLink"
            [image]="tile.image"
            [size]="tile.size"
            [textDisclaimer]="tile.textDisclaimer"
            [isRedirectionExternal]="tile.isExternalLink"
            [status]="tile.status"
            class="rounded-md"
          ></app-tile>
          }
        </div>
        }}
      </div>
      @if(!isJourneyImmature()){
      <div
        class="flex flex-1 flex-col p-6 gap-6 md:gap-10 w-full bg-vinciLavender rounded-xl"
      >
        <h3 class="flex items-center gap-5">
          <icon [name]="'people'" [size]="'2.5rem'"></icon
          >{{'personalizedJourney.clarify.jobPortrait' | transloco }}
        </h3>
        @if (videosLoading()) {
        <loader />
        } @else { @if(videos().length === 0){
        <p class="text-center">
          {{'personalizedJourney.clarify.noVideoFound' | transloco}}
        </p>
        } @else {
        <p class="!font-bold">
          {{ this.shownVideos().length }} {{ this.shownVideos().length > 1 ?
          ('personalizedJourney.clarify.foundManyResults' | transloco) :
          ('personalizedJourney.clarify.foundOneResult' | transloco) }}
        </p>
        <app-language-filter
          [availableLanguages]="availableLanguages()"
          [textToDisplayIfAnySelected]="'personalizedJourney.clarify.manyVideosAudioLanguages' | transloco"
          (updateResults)="onLanguagesChanged($event)"
        ></app-language-filter>
        <div class="grid grid-cols-1 gap-4">
          @for (video of shownVideos(); track $index) {
          <app-card-result
            [title]="video.title"
            [text]="video.text"
            [image]="video.base64Image"
            [link]="video.link"
            [isRedirectionExternal]="true"
            [modalTextDisclaimer]="video.textDisclaimer"
            [variant]="$index % 4 === 0 ? 'primary' : $index % 4 === 1 ? 'quaternary' : $index % 4 === 2 ? 'quinary' : 'tertiary'"
            [isAbleToAddToFavorites]="true"
          ></app-card-result>
          }
        </div>
        @if(extraVideosLoading()) {
        <div class="my-[6.25rem]"><loader /></div>
        } } }
        <div class="flex flex-col sm:flex-row justify-end gap-6">
          @if (store.videosPagination() !== null &&
          store.videosPagination().total > store.videos().length) {
          <app-button
            [text]="'personalizedJourney.clarify.seeMoreJobs' | transloco"
            [variant]="'primary'"
            [disabled]="extraVideosLoading()"
            (buttonClick)="loadMoreVideoTiles()"
          ></app-button>
          }
        </div>
      </div>
      }
    </div>
  </div>
</div>

<app-favorite-tile-error-modal />

@if(isRedirectionExternal() && isModalOpen()) {
<app-modal
  [title]="'components.modal.title' | transloco"
  [buttonText]="'components.modal.ctaButtonText' | transloco"
  [text]="effectiveTextDisclaimer() ? effectiveTextDisclaimer() : 'components.modal.textDisclaimerDefault' | transloco"
  (closeModal)="closeModal()"
  (completeModal)="goToLinkForExternalRedirection()"
  class="tile-modal"
></app-modal>
}
